// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import FormButtons from "./FormButtons-APP_CLIENT.styled";

export interface FormButtonsProps {
  direction: "ltr" | "rtl";
  displayInline: boolean;
}

export default FormButtons;
